export default "__VITE_ASSET__vQg5bbzb__"